import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { PipelineLicenseCategoryDto, PipelineLicenseStageDto } from '@cradua/data';

@Component({
  selector: 'cradua-pipeline-license-stage',
  templateUrl: './pipeline-license-stage.component.html',
  styleUrls: ['./pipeline-license-stage.component.scss']
})
export class PipelineLicenseStageComponent implements OnInit {

  @Input() pipelinelicensestages: PipelineLicenseStageDto[];
  @Input() pipelinelicensecategoryes: PipelineLicenseCategoryDto[];
  pipelinelicensestageForm: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<PipelineLicenseStageDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  selectedPipelineLicenseCategory: any;
  filteredDelete: Array<any> = [];
  loading = true;
  selectedPipelineLicenseStage: any;
  filteredPipelineLicenseStage: Array<any> = [];
  status: boolean;
  selectedPipelineLicenseStageId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.pipelinelicensestageForm = this.fb.group({ PipelineLicenseStages: this.fb.array([]) });
    // this.setPipelineLicenseStage();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display pipelinelicensecategoryes
  setPipelineLicenseStage() {
    const control = this.pipelinelicensestageForm.controls.PipelineLicenseStages as FormArray;
    this.filteredPipelineLicenseStage.forEach((e) => {
      control.push(
        this.fb.group({
          PipelineLicenseStageName: e.PipelineLicenseStageName,
          EstimatedDuration: e.EstimatedDuration,
          PipelineLicenseCategoryId: e.PipelineLicenseCategoryId,
          id: e.id[0],
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.pipelinelicensestageForm.controls.PipelineLicenseStages as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter pipelinelicensestage
  selectPipelineLicenseCategory(event: string) {
    this.filteredPipelineLicenseStage = this.pipelinelicensestages.filter((s) => s.PipelineLicenseCategoryId === event);
    this.selectedPipelineLicenseStageId = event;
    const control = this.pipelinelicensestageForm.controls.PipelineLicenseStages as FormArray;

    if (this.filteredPipelineLicenseStage.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setPipelineLicenseStage();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add PipelineLicenseCategory
  addPipelineLicenseStage() {
    const control = this.pipelinelicensestageForm.controls.PipelineLicenseStages as FormArray;
    control.insert(
      0,
      this.fb.group({
        PipelineLicenseStageName: [''],
        EstimatedDuration: [''],
        PipelineLicenseCategoryId: this.selectedPipelineLicenseStageId,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete pipelinelicensecategory from arrary list
  deletePipelineLicenseStage(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.pipelinelicensestageForm.controls.PipelineLicenseStages as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.pipelinelicensestages.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.pipelinelicensestages[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'pipelinelicensestage';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('pipelinelicensestage');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
